module.exports = __webpack_public_path__ + "images/0c5981b57a4cbe371985013a8290a8f4.png";